import React from 'react';
import styled from 'styled-components';
import CircleLoaderIcon from '~/assets/icons/circle_loading.png';

const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 35px !important;
    height: 35px !important;
    animation: spin 2s linear infinite;
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;

const TextForLoader = styled.div`
  font-size: 14px;
  text-align: center;
  margin-top: 10px;
`;

const CircleLoader = ({ showText = false }: { showText?: boolean }) => {
  return (
    <div
      className="circle-loader"
      style={{
        width: '100%',
        marginTop: '20px'
      }}
    >
      <LoaderContainer>
        <img src={CircleLoaderIcon} alt="Circle Loader" />
      </LoaderContainer>
      {showText && (
        <TextForLoader>
          Hang tight — we're still loading your media. This may take a moment.
        </TextForLoader>
      )}
    </div>
  );
};

export default CircleLoader;
